import { NgModule, SkipSelf, Optional } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { Routes, RouterModule } from '@angular/router';
import { provideAuth } from 'angular-auth-oidc-client'

import {
  AuthModule,
  StsConfigHttpLoader,
  StsConfigLoader
} from 'angular-auth-oidc-client';
import { OidcConfigService } from './services/oidc-config.service';
let routes: Routes = [
  { path: 'access_token', redirectTo: '', pathMatch: 'prefix' },
  { path: 'login/callback', redirectTo: '', pathMatch: 'prefix' }
];

export const httpLoaderFactory = (configService: OidcConfigService) => {
  const config$ = configService.loadConfiguration();
  return new StsConfigHttpLoader(config$);
};
@NgModule({
  imports: [
    HttpClientModule,
    RouterModule.forChild(routes)
  ],
  providers:[
     provideAuth(
      {
        loader: {
          provide: StsConfigLoader,
          useFactory: httpLoaderFactory,
          deps: [OidcConfigService]
        }
      })
  ],
  exports: [RouterModule],
  declarations: []
})
export class OpenIDConnectModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: OpenIDConnectModule
  ) {
    if (parentModule) {
      throw new Error(
        'OpenIDConnectModule is already loaded. Import using the AppModule only'
      );
    }
  }
  initRoutes(isWebComponent) {
    if (isWebComponent) {
      routes = [];
    }
  }
}
